module.exports = __webpack_public_path__ + "img/control_device1.ea5c0420.png";